import { Component  } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-resumen-liquidacion',
  templateUrl: './resumen-liquidacion.component.html',
  styleUrls: ['./resumen-liquidacion.component.scss']
})
export class ResumenLiquidacionComponent   {

  constructor(private loginService:LoginService) { }


  
  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
